<template>
	<guest-template :showNavHeader="false">
		<v-container class="landing-view" fluid>
			<v-row
				justify="center"
				align="start"
				class="hero mb-10 pb-6"
				:style="{
					backgroundImage: `url(${heroImage})`,
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					backgroundRepeat: 'no-repeat'
				}"
			>
				<v-col cols="8" class="pt-8">
					<h1 class="text-center mt-5" style="font-size: 2.25rem">
						Support Your Passion
					</h1>
					<h2
						class="mt-5 mb-5 text-center"
						style="font-size: 18px; font-weight: 400 !important"
					>
						Explore over 1 million nonprofits you can donate to
						through RoundUp App.
					</h2>
					<div style="width: 100%" class="px-2">
						<Search
							class="mb-5"
							:searchOnly="true"
							defaultSearchBarMinWidth="100px"
							breakpoint="xs"
						/>
					</div>
				</v-col>
			</v-row>

			<SearchCategories
				defaultShow="true"
				@click="onShowAll"
				breakpoint="xs"
				:max="8"
				:categoryCount="8"
				listDirection="vertical"
			/>
		</v-container>
	</guest-template>
</template>

<script>
import GuestTemplate from '../../templates/guestTemplate.vue'

export default {
	name: 'LandingView',
	components: {
		GuestTemplate
	},
	props: {
		heroImage: {
			type: String,
			default:
				'https://roundup-website.s3.amazonaws.com/find-nonprofit-hero.jpg'
		}
	},
	data: () => ({}),
	methods: {
		onShowAll(cat) {
			if (cat) {
				this.onShowResults({ category: cat.title })
			} else {
				this.$router.push({ name: 'categories' })
			}
		},

		onShowResults(params) {
			this.$router.push({
				name: 'results',
				params
			})
		}
	}
}
</script>
<style lang="scss" scoped>
@import '../../styles/typography-screen';

.landing-view {
	min-height: 100vh;
	background: $white;
	padding-bottom: 66px;
	h1 {
		@extend .font-regular;
		font-size: 44px;
		font-family: 'Bitter', serif;
		color: #333 !important;
		margin: 0;
		line-height: normal !important;
	}
	.hero > .col {
		display: flex;
		flex-direction: column;
		max-width: 100%;
		justify-content: center;
		align-items: center;
		flex: 0 0 100%;
	}
	h2 {
		font-size: 20px;
		font-weight: 300;
		color: #333 !important;
		line-height: normal !important;
	}
}

.landing-view::v-deep .category-list-title {
	font-weight: 600;
}
</style>
